<template>
    <div class="cc-carrier" v-if="shouldCarrierBeShown" @click="setCarrier(carrier)">
        <div class="cc-carrier__selector">
            <div class="cc-selector cc-selector--radio cc-selector--big" v-bind:class="{'cc-active': isCarrierSelectedCarrier}"></div>
        </div>
        <div class="cc-carrier__image">
            <img :src="carrier.img" :alt="carrier.name" class="cc-carrier__image__thumbnail">
        </div>
        <div class="cc-carrier__description" v-bind:class="{'cc-has-charge': carrier.additionalCharge}">
            <div class="cc-carrier__title">{{ carrier.name }}</div>
            <div class="cc-carrier__subtitle">{{ carrier.availabilityDate }}</div>
            <div class="cc-carrier__branch" v-if="carrier.module === 'shaim_zasilkovna_widget'">
                {{ shaim_zasilkovna_widget.id ? shaim_zasilkovna_widget.name : ''}}
                <button class="cc-button cc-button--delivery-branch" @click.stop="showShaimZasilkovnaWidget(carrier)">{{ shaim_zasilkovna_widget.id ? translations['Change'] : translations['Select branch'] }}</button>
            </div>
            <div class="cc-carrier__branch" v-if="carrier.module === 'shaim_balikovna'">
              <shaim-balikovna :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
            </div>
        </div>
        <div class="cc-carrier__charges" v-if="carrier.additionalCharge">
            <div class="cc-charge">
                <div class="cc-charge__title">
                    {{ carrier.additionalCharge.title }}:
                </div>
                <div class="cc-charge__value">
                    {{ carrier.additionalCharge.value }}
                </div>
            </div>
        </div>
        <div class="cc-carrier__prices">
            <div class="cc-carrier__price">{{ displayCarrierPrice }}</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ShaimBalikovna from "../_common/modules/shaim_balikovna/ShaimBalikovna";

    export default {
      components: {ShaimBalikovna},
      computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCarrier: state => state.selectedCarrier,
                shaim_zasilkovna_widget: state => state.shaim_zasilkovna_widget,
                currentCarrier: state => state.currentCarrier,
                config: state => state.config,
                user: state => state.user,
            }),
            shouldCarrierBeShown: function () {
                if (this.selectedCarrier === null || this.selectedCarrier === '') {
                    return true
                }

                return this.carrier.id_carrier === this.selectedCarrier;
            },
            isCarrierSelectedCarrier: function () {
                return this.carrier.id_carrier === this.selectedCarrier;
            },
            displayCarrierPrice: function () {
                return this.carrier.free ? this.translations['Free'] : this.carrier.formattedPrices.price;
            },
        },
        methods: {
            setCarrier: function (carrier) {
                const that = this;

                this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(function () {
                    if (carrier.module === 'packetery') {
                        that.showPacketeryWidget(carrier);
                    }

                    if (carrier.module === 'shaim_zasilkovna_widget') {
                        that.showShaimZasilkovnaWidget(carrier);
                    }

                    document.querySelector('.cc-carriers').scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                });
            },
            unsetCarrier: function () {
                this.$store.dispatch('SELECT_CARRIER', null);
                this.$store.dispatch('SELECT_PAYMENT', null);
            },
            showPacketeryWidget: function (carrier) {
              const countries = this.config.countries
                  .filter(item => parseInt(item.id) === parseInt(this.user.deliveryAddress.country))
                  .map(item => item.iso.toLowerCase())
                  .join(',');
              const version = carrier.extra.version.replaceAll('.', '');
              if (version >= 213) {
                Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
                  if (item === null) {
                    this.unsetCarrier();
                    return this.$store.commit('SET_PACKETERY_V213', {
                      id: null,
                      name: null,
                      currency: null,
                      pickupPointType: null,
                      carrierId: null,
                      carrierPickupPointId: null,
                      prestashopCarrierId: null,
                    });
                  }

                  this.$store.dispatch('UPDATE_PACKETERY_V213', {
                    id: item.id,
                    name: item.name,
                    currency: item.currency,
                    pickupPointType: item.pickupPointType,
                    carrierId: item.carrierId,
                    carrierPickupPointId: item.carrierPickupPointId,
                    prestashopCarrierId: carrier.id,
                  }).then(() => {
                    this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier);
                  });
                }, {
                  country: countries,
                });
              } else {
                Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
                    if (item === null) {
                        this.unsetCarrier();
                        return this.$store.commit('SET_PACKETERY', {
                            id: null,
                            name: null,
                            currency: null,
                        });
                    }

                    this.$store.dispatch('UPDATE_PACKETERY', {
                        id: item.id,
                        name: item.name,
                        currency: item.currency,
                    }).then(() => {
                        this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier);
                    });
                });
              }
            },
            showShaimZasilkovnaWidget: function (carrier) {
              const countries = this.config.countries
                  .filter(item => parseInt(item.id) === parseInt(this.user.deliveryAddress.country))
                  .map(item => item.iso.toLowerCase())
                  .join(',');
                Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
                    if (item === null) {
                        this.unsetCarrier();
                        return this.$store.commit('SET_SHAIM_ZASILKOVNA_WIDGET', {
                            id: null,
                            name: null,
                            currency: null
                        });
                    }
                    item.secret_key = carrier.extra.secret_key;
                    this.$store.dispatch('UPDATE_SHAIM_ZASILKOVNA_WIDGET', item)
                        .then(() => {
                            this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(() => {
                                document.querySelector('.cc-carriers').scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                });
                            });
                        });
                }, {
                  country: countries,
                });
            }
        },
        mounted() {
            const loadPacketeryScript = () => {
              if (this.carrier.module !== 'packetery' || this.carrier.module !== 'shaim_zasilkovna_widget') {
                return;
              }
              const version = this.carrier.extra.version.replaceAll('.', '');
              const packeteryApi = document.createElement('script');
              if (version >= 213) {
                packeteryApi.setAttribute('src', 'https://widget.packeta.com/v6/www/js/library.js');
              } else {
                packeteryApi.setAttribute('src', 'https://widget.packeta.com/www/js/library.js');
              }
              document.head.appendChild(packeteryApi);
            };

            loadPacketeryScript();
        },
        name: 'Carrier',
        props: [
            'carrier',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-carrier {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            border-width: 1px;
            border-style: solid;
            border-color: $border-color;

            & + .cc-carrier {
                margin-top: 1.5rem;
            }

            &.cc-invalid {
                outline: none;
                box-shadow: $invalid-input-shadow;
            }
        }

        .cc-carrier__selector {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 10%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-carrier__selector {
                align-items: flex-start;
                justify-content: flex-start;
                width: 20%;
            }
        }

        .cc-carrier__image {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 10%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-carrier__image {
                align-items: flex-start;
                width: 20%;
                padding-right: 0;
                padding-left: 0;
            }
        }

        .cc-carrier__image__thumbnail {
            display: inline-block;
            max-width: 100%;
        }

        .cc-carrier__description {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: center;
            width: 60%;
            padding: 1.5rem;

            &.cc-has-charge {
                width: 40%;
            }
        }

        .cc-carrier__title {
            font-size: 16px;
        }

        .cc-carrier__subtitle {
            font-size: 16px;
            margin-top: 1rem;
            color: $light-grey;
        }

        @include mobile {
            .cc-carrier__subtitle {
                margin-top: 1.5rem;
            }
        }

        .cc-carrier__charges {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 20%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-carrier__charges {
                justify-content: flex-start;
                width: 60%;
                margin-left: 40%;
                padding-top: 0;
            }
        }

        .cc-charge {
            display: block;
        }

        .cc-charge__title {
            color: #666666;
            display: inline;
            font-size: 16px;
        }

        .cc-charge__value {
            display: inline;
            font-size: 18px;
        }

        .cc-carrier__prices {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 20%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-carrier__prices {
                justify-content: flex-start;
                width: 60%;
                margin-left: 40%;
                padding-top: 0;
            }
        }

        .cc-carrier__price {
            font-size: 18px;
            font-weight: bold;
        }
    }
</style>
<style lang="scss">
  .cc-theme--profimodel .cc-carrier__branch .cc-button--delivery-branch {
    font-size: 13px;
    font-weight: bold;
    padding: 0.5rem;
    color: #5c5b56;
    border-width: 2px;
    border-style: solid;
    border-color: #e55b10;
    border-radius: 3px;
    background-color: #ffffff;

  &:active {
     box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
   }
  }
</style>
